import React from 'react';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard">
      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Usuarios Activos</h3>
          <p className="dashboard-value">0</p>
        </div>
        <div className="dashboard-card">
          <h3>Inversiones Totales</h3>
          <p className="dashboard-value">€0</p>
        </div>
        <div className="dashboard-card">
          <h3>Proyectos Activos</h3>
          <p className="dashboard-value">0</p>
        </div>
        <div className="dashboard-card">
          <h3>Rentabilidad</h3>
          <p className="dashboard-value">0%</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
